import { AutocompleteFilter } from "./AutocompleteFilter";
import { UiCropFilterValue } from "portal/utils/categoryCollection/predictionPoints";
import { useSortedCrops } from "portal/utils/hooks/useCrops";
import { useTranslation } from "react-i18next";
import React, { FC, useMemo } from "react";

interface VeselkaCropFilterProps {
  serial?: string;
  label: string;
  value: UiCropFilterValue[];
  onChange: (value: UiCropFilterValue[]) => void;
}

export const VeselkaCropFilter: FC<VeselkaCropFilterProps> = ({
  serial,
  label,
  value,
  onChange,
}) => {
  const { i18n } = useTranslation();
  const {
    sortedCrops,
    isFetching: isLoading,
    isError,
  } = useSortedCrops({ serial });
  const options = useMemo(
    () =>
      (serial ? sortedCrops?.enabled : sortedCrops?.all)
        ?.toSorted((a, b) =>
          a.localeName.localeCompare(b.localeName, i18n.language)
        )
        .map(({ id, localeName }) => ({ id, name: localeName })) ?? [],
    [i18n.language, serial, sortedCrops?.all, sortedCrops?.enabled]
  );

  return (
    <AutocompleteFilter
      loading={isLoading}
      loadingError={isError}
      label={label}
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};
